"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsAll = void 0;
// eslint-disable-next-line import/prefer-default-export
function containsAll(container, contained) {
    return contained.every((element) => container.includes(element));
}
exports.containsAll = containsAll;
